import { render, staticRenderFns } from "./UserTypeDisplay.vue?vue&type=template&id=563528d9&scoped=true&"
import script from "./UserTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./UserTypeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeDisplay.vue?vue&type=style&index=0&id=563528d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563528d9",
  null
  
)

component.options.__file = "UserTypeDisplay.vue"
export default component.exports